import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({
  eyebrow,
  title,
  description,
  align = "left",
  testId,
}) => {
  const alignment = align === "center" ? "mx-auto text-center" : "text-left";

  return (
    <Reveal className={`max-w-3xl ${alignment}`}>
      <div data-testid={testId} className="space-y-4">
        {eyebrow ? (
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-brand-teal">
            {eyebrow}
          </p>
        ) : null}
        <h2 className="font-heading text-4xl font-semibold tracking-tight text-slate-950 md:text-5xl">
          {title}
        </h2>
        <p className="text-base leading-8 text-slate-600 md:text-lg">{description}</p>
      </div>
    </Reveal>
  );
};